import { LoadingOutlined } from "@ant-design/icons";
import { Checkbox, Form, Input, Modal, Spin, message } from "antd";
import React, { useRef, useState } from "react";
import { COOKIE_CONSTANTS, SET_COOKIE } from "../../helpers/cookieHelper";
import { LOGGER } from "./../../helpers/logger";
import IndexOfForgotPassword from "./forgot-password/IndexOfForgotPassword";

import {
  confirmSignUp,
  fetchAuthSession,
  resendSignUpCode,
  signIn,
} from "aws-amplify/auth";
import IsToShow from "../../components/is-show/IsToShow";
import {
  LOCAL_STORAGE_KEY,
  SET_LOCAL_STORAGE,
} from "../../helpers/localStorage";
import { RE_DIRECT_TO } from "../../helpers/redirectHelper";
import { showError, showSuccess } from "../../helpers/alerts";
import Loader from "../../components/spinner/Loader";
import CITest from "./ClTest";
import AddRolesForm from "./../roles/platform-admin/manage-roles/AddRolesForm";

function LoginForm() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShowOtp, setIsShowOtp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  async function handleConfirmSignUp(values) {
    const { email, otp } = values;
    try {
      const { isSignUpComplete, nextStep } = await confirmSignUp({
        username: email,
        confirmationCode: otp,
      });
      LOGGER("Sign-up confirmation response:", { isSignUpComplete, nextStep });
      if (isSignUpComplete) {
        LOGGER("Sign up confirmed");
        SET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.changePassword, true);
        handleSignIn(values);
      }
    } catch (error) {
      setIsLoading(false);
      LOGGER("Error Confirming signIn:", error);
      if (
        error.message ===
        "User cannot be confirmed. Current status is CONFIRMED"
      ) {
        handleSignIn(values);
      } else {
        showError(error.message || "Error confirming sign-up.");
      }
    }
  }
  async function currentAuthenticatedUser() {
    try {
      const session = await fetchAuthSession();
      LOGGER(JSON.stringify(session.tokens.idToken.payload, null, 5));
      LOGGER(session?.tokens?.idToken?.toString());
      return session?.tokens?.idToken?.toString();
    } catch (err) {
      LOGGER(err);
    }
  }
  async function handleSignIn(values) {
    const { email, password } = values;
    try {
      const user = await signIn({
        username: email.toLowerCase(),
        password: password,
      });
      SET_LOCAL_STORAGE("email", email.toLowerCase());
      LOGGER("Sign-in response:", user);
      if (user.nextStep.signInStep === "CONFIRM_SIGN_UP") {
        setIsShowOtp(true);
        setIsLoading(false);
      } else {
        const res = await currentAuthenticatedUser();
        SET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.cognitoJWTIdentity, res);
        SET_COOKIE(COOKIE_CONSTANTS.USER, { user: true });
        RE_DIRECT_TO("/role-selection");
        // setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      LOGGER("Error signing in:", error);
      showError(error.message || "Error signing in.");
      if (error.message == "Password attempts exceeded") {
        showError({
          content: error.message,
          duration: 10,
        });
      }
    }
  }
  const emailRef = useRef(null);
  const onFinish = (values) => {
    setIsLoading(true);
    LOGGER("form:", values);
    emailRef.current = values.email;
    if (values.otp) {
      handleConfirmSignUp(values);
    } else {
      handleSignIn(values);
    }
  };
  const onFinishFailed = (errorInfo) => {
    LOGGER("Failed:", errorInfo);
  };
  async function resendOTP() {
    try {
      await resendSignUpCode({ username: emailRef.current });
      showSuccess("Verification code sent successfully");
    } catch (error) {
      showError(error);
    }
  }

  return (
    <div className="lg:px-9">
      <div className=" text-center">
        <h1 className=" text-[#005EB8] font-bold	text-[40px]">Welcome Back!</h1>
        <p className="text-[#626476]  mt-3 text-[14px]">
          Enter your email and password.
        </p>
      </div>
      <div className=" p-9">
        <Form
          scrollToFirstError={true}
          name="basic"
          // variant="filled"

          layout="vertical"
          requiredMark={false}
          initialValues={{
            remember: true,
          }}
          validateTrigger="onBlur"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            normalize={(value) => value.trim()}
            label={<p className="text-[14px] text-[#626476]">Email</p>}
            name="email"
            rules={[
              {
                required: true,
                message: "Please enter your email!",
              },
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
            ]}
          >
            <Input
              autoComplete="off"
              onInput={(e) => {
                if (e.target.value.trim() == "") {
                  e.target.value = "";
                }
              }}
              className="py-[10px] px-[10px] "
            />
          </Form.Item>
          <Form.Item
            normalize={(value) => value.trim()}
            label={<p className="text-[14px] text-[#626476]">Password</p>}
            name="password"
            rules={[
              {
                required: true,
                message: "Please enter your password!",
              },
            ]}
          >
            <Input.Password
              autoComplete="off"
              onInput={(e) => {
                if (e.target.value.trim() == "") {
                  e.target.value = "";
                }
              }}
              className="py-[10px] px-[10px]"
            />
          </Form.Item>

          <IsToShow show={isShowOtp}>
            <div
              onClick={resendOTP}
              className="text-[14px] text-[#626476] cursor-pointer underline z-10 absolute right-[77px]"
            >
              Resend
            </div>
            <Form.Item
              normalize={(value) => value.trim()}
              label={
                <div className="flex items-center   ">
                  <p className="text-[14px] text-[#626476]">
                    Verification Code
                  </p>
                </div>
              }
              name="otp"
              rules={[
                {
                  required: true,
                  message: "Please enter your verification code!",
                },
              ]}
            >
              <Input
                onInput={(e) => {
                  if (e.target.value.trim() == "") {
                    e.target.value = "";
                  }
                }}
                className="py-[10px] px-[10px]"
              />
            </Form.Item>
          </IsToShow>
          <div className="flex items-center mb-3">
            <Form.Item
              className="!mb-0"
              name="remember"
              valuePropName="checked"
            >
              <Checkbox className="text-[14px]">Remember me</Checkbox>
            </Form.Item>
            <p
              className="ms-auto text-[14px] text-blue-600 hover:text-blue-900"
              role="button"
              onClick={showModal}
            >
              <u> Forgot Password</u>
            </p>
          </div>
          <button
            disabled={isLoading}
            type="submit"
            className="w-[100%] rounded-[5px] flex justify-center items-center text-[13px] font-medium text-white py-[10px] bg-[#005EB8]"
          >
            <Loader isLoading={isLoading} />
            Sign In
          </button>
        </Form>
        <Modal
          destroyOnClose={true}
          title=""
          open={isModalOpen}
          onCancel={closeModal}
          maskClosable={false}
          footer={null}
        >
          <IndexOfForgotPassword />
        </Modal>
        {/* <JsonViewer data={mutation} /> */}
        {/* <CITest /> */}
        {/* <AddRolesForm /> */}
      </div>
    </div>
  );
}

export default LoginForm;
